import { motion } from "framer-motion";
import { Mail, Clock, Gift } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export default function Contattaci() {
  return (
    <div className="relative min-h-screen bg-[#06150F] text-[#FAF6EE]">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-[380px] bg-[radial-gradient(ellipse_at_top,rgba(90,15,25,0.5),transparent_65%)]"
      />
      <SiteHeader />
      <main className="relative z-10 mx-auto max-w-3xl px-5 pb-20 pt-14 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-amber-300/90">Contattaci</p>
          <h1 className="font-display mt-3 text-3xl font-bold text-amber-100 sm:text-4xl">Parliamone</h1>
          <p className="mt-3 text-sm leading-relaxed text-emerald-100/70 sm:text-base">
            Domande sul calendario, su un codice regalo o su una sorpresa? Scrivici: il nostro team
            ti risponde il prima possibile.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          data-testid="contact-card"
          className="mt-10 rounded-3xl border border-amber-500/25 bg-[#0A1D15]/80 p-8 text-center shadow-[0_30px_80px_rgba(0,0,0,0.45)] backdrop-blur-xl sm:p-10"
        >
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-400/15">
            <Mail className="h-7 w-7 text-amber-300" />
          </div>
          <h2 className="mt-5 font-display text-2xl font-bold text-amber-100">Scrivici una email</h2>
          <a
            href="mailto:info@ilcalendariodellavvento.it"
            data-testid="contact-email-link"
            className="mt-3 inline-block break-all font-mono text-lg font-semibold text-amber-200 underline decoration-amber-400/40 underline-offset-4 transition-colors hover:text-amber-100"
          >
            info@ilcalendariodellavvento.it
          </a>
          <div>
            <a
              href="mailto:info@ilcalendariodellavvento.it?subject=Richiesta%20informazioni%20—%20Avvento%20d'Oro"
              data-testid="contact-email-button"
              className="mt-6 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-amber-500 via-amber-400 to-yellow-600 px-7 py-3.5 font-bold text-[#1A1204] shadow-lg transition-all duration-300 hover:scale-[1.03] hover:shadow-amber-500/30"
            >
              <Mail className="h-4 w-4" /> Apri il tuo programma di posta
            </a>
          </div>

          <div className="mt-9 grid gap-4 text-left sm:grid-cols-2">
            <div className="rounded-2xl border border-emerald-400/15 bg-[#0C241A]/60 p-5">
              <Clock className="h-4 w-4 text-emerald-300" />
              <p className="mt-2.5 text-sm font-semibold text-amber-100">Tempi di risposta</p>
              <p className="mt-1 text-xs leading-relaxed text-emerald-100/65">
                Rispondiamo in genere entro 2 giorni lavorativi, festivi permettendo.
              </p>
            </div>
            <div className="rounded-2xl border border-emerald-400/15 bg-[#0C241A]/60 p-5">
              <Gift className="h-4 w-4 text-emerald-300" />
              <p className="mt-2.5 text-sm font-semibold text-amber-100">Problemi con una sorpresa?</p>
              <p className="mt-1 text-xs leading-relaxed text-emerald-100/65">
                Le sorprese sono erogate dai brand partner: indicaci il giorno della casella e il
                tuo codice calendario per aiutarti più in fretta.
              </p>
            </div>
          </div>
        </motion.div>
      </main>
      <SiteFooter />
    </div>
  );
}
